import { message } from "antd";
import { handleApiSuccess } from "utils";

/** Show API success plus invoice email delivery feedback from response.data.email */
export function handleInvoiceSaveResponse(response) {
  handleApiSuccess(response);
  const email = response && response.data && response.data.email;
  if (!email) return;

  if (email.sent) {
    message.success(`Invoice emailed to ${email.to}`);
    return;
  }
  if (email.message) {
    message.warning(email.message);
    return;
  }
  if (email.skipped === "no recipient") {
    message.warning(
      "Invoice saved but no email was sent — Bill To email is empty."
    );
    return;
  }
  if (email.error) {
    message.error(`Invoice saved but email failed: ${email.error}`);
  }
}
